import { PDFRelatorioDespesasProps } from "features/relatorios/typings";
import { PDFRelatorioBase } from "components/PDF";
import useRelatorioDespesaPdfColumns from "../hooks/useRelatorioDespesaPdfColumns";

function PDFRelatorioDespesa(props: PDFRelatorioDespesasProps) {
  const selectedFields = (props as PDFRelatorioDespesasProps).selectedFields;

  const columns = useRelatorioDespesaPdfColumns(selectedFields);

  return (
    <PDFRelatorioBase
      title="Relatório de despesas"
      relatorioData={props as PDFRelatorioDespesasProps}
      columns={columns}
      totalRow={(props as PDFRelatorioDespesasProps).total}
      includeAttachmentsPage={selectedFields?.includes("anexos")}
      includeMinHeight={!props?.assinaturas?.length}
    />
  );
}

export default PDFRelatorioDespesa;
